import Keycloak from 'keycloak-js';
import KeycloakConfig from '../../keycloak.json';
export function getKeycloak() {
    const keycloak = new Keycloak(KeycloakConfig);
    return keycloak;
}